export default { 
  typesTrade (state) {
    return state.typesTrade
  },
}